
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { useTranslation } from 'react-i18next';

const DatePicker = ({ value, setIsDate, handleDateChange }) => {
    const { t } = useTranslation();
    return (
        <div>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['StaticDatePicker']}>
                    <DemoItem>
                        <StaticDatePicker value={dayjs(value)} onChange={handleDateChange}
                            slotProps={{
                                actionBar: {
                                    actions: []
                                }
                            }}
                            sx={{
                                '& .MuiPickersDay-root.Mui-selected': {
                                    backgroundColor: '#FA6400 !important',
                                },
                                '& .MuiPickersDay-root.MuiPickersDay-today': {
                                    border: '2px solid #FA6400',
                                },
                            }}
                        />
                        <div className="date_button">
                            <button onClick={() => setIsDate(false)} className='px-[8px] py-[6px] text-blue-500 w-[70px]'>{t("CANCEL")}</button>
                            <button onClick={() => setIsDate(false)} className='px-[8px] py-[6px] text-blue-500 w-[70px]'>{t("OK")}</button>
                        </div>
                    </DemoItem>
                </DemoContainer>
            </LocalizationProvider>
        </div>
    )
}

export default DatePicker